import React, { useCallback } from 'react';
import { ButtonGroup } from 'app/src/elements/buttons';
import { ButtonContainer, Button } from './elements';
import { View, Text } from 'react-native';
import { } from './queries';
import { useMutation } from '@apollo/client';
import colors from '../../styles/colors';

const PreBidAlert = ({sale, setShowModal}) => {

  const handleAccept = () => {
    // createBuyer({ variables: input });
  };


  return(
    <>
      <View style={{marginBottom: '20px'}}>
        <Text>There are pre-bids on this asset. Include?</Text>
      </View>

      <ButtonGroup style={{marginBottom: '20px'}}>
        <Button
          title="Ignore Pre-Bids"
          color={colors.elRed}
          onPress={() => setShowModal(false)}
        />
        <Button
          title="Accept"
          color={colors.biddingAcceptGreen}
          onPress={() => handleAccept()}
        />
      </ButtonGroup>

    </>
  )
}

export default PreBidAlert;